import { lazy } from 'react';

export default [
  {
    title: 'LarcRed Rightcare',
    component: lazy(() => import('./LarcRightCareRed')),
    url: '/larc/RightcareRed',
    requirePermission: true,
    roles: ['Client'],
  },
  {
    title: 'LarcBook Appointment',
    component: lazy(() => import('./LarcBookAppointment')),
    url: '/larc/appointment/:id/:shareId',
    requirePermission: true,
    roles: ['Client'],
  },
  {
    title: 'LarcBook Appointment',
    component: lazy(() => import('./BookingConfirmation')),
    url: '/larc/booking-confirmed/:id/:shareId',
    requirePermission: true,
    roles: ['Client'],
  },
];
